import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap/lib';
import Tooltip from '../../components/Tooltip';

import './ApplicantTable.scss';
import { CreditApplicantField } from './CreditApplicantField';
import { getFieldConfig, getCreditFormKey } from './creditApplicationFields';

function ApplicantTable({
  title,
  applicantKey,
  creditFormConfig,
  setCreditFormConfig,
  referencesEnabled,
}) {
  const [relevantFields, dependencyFields] = getFieldConfig(applicantKey);
  return (
    <Table className="applicant-form-table">
      <thead>
        <tr>
          <th>Input</th>
          <th>Mandatory</th>
          <th>
            Dependencies{' '}
            <Tooltip
              width={250}
              text="Optional inputs become mandatory if any of its dependencies was entered in the form."
            >
              <i className="glyphicon glyphicon-info-sign" />
            </Tooltip>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan="3">
            <b>{title}</b>
          </td>
        </tr>
        {relevantFields.map(({ label, id }) => (
          <CreditApplicantField
            key={id}
            id={id}
            label={label}
            creditFormKey={getCreditFormKey(applicantKey, id)}
            allDependencyFields={dependencyFields}
            setCreditFormConfig={setCreditFormConfig}
            creditFormConfig={creditFormConfig}
            referencesEnabled={referencesEnabled}
          />
        ))}
      </tbody>
    </Table>
  );
}

ApplicantTable.propTypes = {
  title: PropTypes.string,
  applicantKey: PropTypes.string,
  creditFormConfig: PropTypes.object,
  setCreditFormConfig: PropTypes.func,
  referencesEnabled: PropTypes.bool,
};

export default React.memo(ApplicantTable);
